import React from 'react'
import Moment from 'moment'
import { FirestoreCollection } from 'react-firestore'

import FirebaseAuth from '../misc/FirebaseAuth'
import deleteTouch from '../../actions/deleteTouch'
import colors from '../../styles/colors'
import {
  AppAction,
} from '../../styles/links'

const LastTouch = ({person}) => (
  <FirebaseAuth>
    { ({isLoading, error, auth}) => {

      if (error) {
        return null
      }

      if (isLoading) {
        return <div>loading...</div>
      }

      if (!auth) {
        return null
      }

      return <FirestoreCollection
        path={`touches`}
        filter={[
          ['personId', '==', person.id],
          ['createdBy', '==', auth.uid],
        ]}
      >
        { ({error, isLoading, data}) => {
          if (error) {
            return null
          }

          if (isLoading) {
            return <p>loading...</p>
          }
          
          if (data.length === 0) {
            return <p>not contacted yet</p>
          }

          const lastTouch = data.sort( (a, b) => a.date.toMillis() - b.date.toMillis())[0]
          const color = person.showAsLate ? colors.red : colors.primaryText
          return <p>
            last contact: <span style={{color}}>{Moment(lastTouch.date.toDate()).fromNow()}</span>
            {' '}
            <AppAction onClick={() => deleteTouch(lastTouch)}>delete</AppAction>
          </p>
        }}
      </FirestoreCollection>

    }}
  </FirebaseAuth>
)

export default LastTouch



// WEBPACK FOOTER //
// ./src/views/person/LastTouch.js